import React, { useState, useEffect } from 'react';
import Header from '../Header/Header'
import HeaderDash from '../../Components/Admin/HeaderDash/HeaderDash'
import LogsWhatsappData from '../../Components/Admin/LogsWhatsappData/LogsWhatsappData'
import SinPermisos from '../../Components/SinPermisos/SinPermisos';
import { fetchUsuario, getUsuario } from '../../Components/user';
import { puedeVerMenu } from '../../Helpers/rolesPermisos';

export default function LogsWhatsapp() {
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchData = async () => {
            await fetchUsuario();
            setLoading(false);
        };
        fetchData();
    }, []);

    const usuarioLegued = getUsuario();
    return (
        <div className='containerGrid'>
            <Header />
            <section className='containerSection'>
                <HeaderDash />
                <div className='container'>
                    {loading ? (
                        <></>
                    ) : usuarioLegued?.idUsuario && puedeVerMenu(usuarioLegued.rol, 'logs-whatsapp') ? (
                        <LogsWhatsappData />
                    ) : (
                        <SinPermisos />
                    )}
                </div>
            </section>
        </div>
    )
}
